import './Radio.scss';

export interface RadioProps {
  value: string;
  name?: string;
  onChange?: (value: string) => void;
  label?: string;
  checked?: boolean;
  disabled?: boolean;
}

export const Radio = ({
  checked = false,
  label,
  disabled = false,
  value,
  name,
  onChange,
  ...props
}: RadioProps) => {

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    if (disabled) return;
    onChange?.(e.target.value);
  };

  return (
    <div className='radio-wrap'>
      <label className={`radio${disabled ? ' radio--disabled' : ''}`}>
        <input
          className={`radio__input${disabled ? ' radio__input--disabled' : ''}`}
          type='radio'
          name={name}
          value={value}
          checked={checked}
          disabled={disabled}
          onChange={handleChange}
          {...props}
        />
        {label && (
          <span className={`radio__label${disabled ? ' radio__label--disabled' : ''}`}>
            {label}
          </span>
        )}
      </label>
    </div>
  );
};

export default Radio;
